module.exports = __webpack_public_path__ + "static/media/scooter-trees.395f010c.png";